import { MasonryDataById } from "common/materials/library/masonryDataById";
import { MasonryTrimKind } from "common/materials/masonryTypes";
import type { MaterialSrc } from "common/materials/materialSrc";

type MaterialSrcData = [templateId: number, layerConfigId: number | null, colorId: number | null];

const masonryTrimKindIndex: Record<MasonryTrimKind, number> = {
  [MasonryTrimKind.Base]: 0,
  [MasonryTrimKind.Header]: 1,
  [MasonryTrimKind.Rowlock]: 2,
};

function materialSrcFromData(materialSrcData: MaterialSrcData): MaterialSrc {
  const [templateId, layerConfigId, colorId] = materialSrcData;
  const materialSrc: MaterialSrc = { templateId };

  if (layerConfigId !== null) {
    materialSrc.layerConfigId = layerConfigId;
  }
  if (colorId !== null) {
    materialSrc.colorId = colorId;
  }

  return materialSrc;
}

export function masonryMaterialSrc(masonryId: number, trimKind: MasonryTrimKind): MaterialSrc | undefined {
  const masonryData = MasonryDataById[masonryId];
  if (masonryData === undefined) {
    return undefined;
  }

  const materialSrcData = masonryData[masonryTrimKindIndex[trimKind]];
  if (materialSrcData === undefined) {
    return undefined;
  }

  return materialSrcFromData(materialSrcData);
}

export function allMasonryMaterialSrcs(masonryId: number): Record<MasonryTrimKind, MaterialSrc> | undefined {
  const masonryData = MasonryDataById[masonryId];
  if (masonryData === undefined) {
    return undefined;
  }

  return {
    [MasonryTrimKind.Base]: materialSrcFromData(masonryData[masonryTrimKindIndex[MasonryTrimKind.Base]]),
    [MasonryTrimKind.Header]: materialSrcFromData(masonryData[masonryTrimKindIndex[MasonryTrimKind.Header]]),
    [MasonryTrimKind.Rowlock]: materialSrcFromData(masonryData[masonryTrimKindIndex[MasonryTrimKind.Rowlock]]),
  };
}
